export default __webpack_public_path__ + "static/media/blockbusterdle.24190672.svg";